import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink, PrimaryButton } from '../../components';
import css from './ListingPage.module.css';

import CustomAdvice from '../../assets/customAdvice.png';

const SectionCustomAdvice = () => {
  return (
    <section className={css.customAdviceSection}>
      <h2 className={`${css.heading}`}>
        <FormattedMessage id="SectionCustomAdvice.title" />
      </h2>
      <div className={`${css.content} ${css.customAdviceContainer}`}>
        <div className={css.informationContent}>
          <h2 className={`${css.heading} ${css.customAdviceheading}`}>
            <FormattedMessage id="SectionCustomAdvice.heading" />
          </h2>

          <p className={css.description}>
            <FormattedMessage id="SectionCustomAdvice.description" />
          </p>

          <NamedLink name="CMSPage" params={{ pageId: 'contact-us' }} className={css.SectionCustomAdviceButton}>
            <FormattedMessage id="SectionCustomAdvice.contactButton" />
          </NamedLink>
        </div>
        <div className={css.imgContent}>
          <img src={CustomAdvice} />
        </div>
      </div>
    </section>
  );
};

export default SectionCustomAdvice;
